import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Home } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const UniversalHomeButton = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Don’t render on home route
  if (location.pathname === '/') return null;

  const handleClick = () => {
    navigate('/');
  };

  return (
    <AnimatePresence>
      <motion.div
        onClick={handleClick}
        className="fixed bottom-6 left-6 z-[999] group w-14 h-14 md:w-16 md:h-16 cursor-pointer select-none"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 30 }}
        transition={{ duration: 0.3 }}
      >
        {/* VISIBILITY & STYLE FIX: 
          1. Changed from orange to the premium Indigo-to-Blue gradient.
          2. Fixed 'backdrop-blue-md' typo to 'backdrop-blur-md'.
          3. Added a subtle white border and shadow glow for visibility.
        */}
        <motion.div
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
          className="w-full h-full flex items-center justify-center rounded-full
          bg-gradient-to-tr from-indigo-600 to-blue-500 border border-white/20 
          shadow-xl transition-all duration-500 group-hover:from-blue-500 
          group-hover:to-indigo-600 group-hover:shadow-[0_0_20px_rgba(59,130,246,0.5)]"
        >
          <Home
            className="w-7 h-7 text-white transition-transform duration-300 group-hover:scale-110"
            strokeWidth={2.5}
          />
        </motion.div>

        {/* LABEL FIX: 
          Repositioned label to the top (consistent with ScrollToTop)
          and updated color to Indigo for high-end professional look.
        */}
        <div
          className="absolute text-indigo-400 font-bold text-xs uppercase tracking-widest
          left-1/2 transform -translate-x-1/2 -top-6
          opacity-0 group-hover:opacity-100 group-hover:-top-8
          transition-all duration-300 whitespace-nowrap pointer-events-none"
        >
          Home
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default UniversalHomeButton;